import type { FC } from 'react';
import { useState, Fragment } from 'react';
import { Button, Table, TableCell, TableRow } from '@material-ui/core';
import Plus from 'src/components/icons/Plus';
import Minus from 'src/components/icons/Minus';
import { formatNumber } from 'src/utils/functions';

const FunnelDetail: FC<{ item: any }> = ({
  item,
}) => {
  const [open, setOpen] = useState(item.detail?.open);
  const keyChild = `rowKey-child-${item.id}`;

  return (
    <Fragment key={item.id}>
      <TableRow>
        <TableCell>
          <Button onClick={() => setOpen(!open)} style={{ padding: '0px', minWidth: '0px' }}>
            {!open && (<Plus />)}
            {open && (<Minus />)}
            {item.titulo}
          </Button>
        </TableCell>
        <TableCell width={150} align="right">
          {item.cantidad}
        </TableCell>
        <TableCell width={150} align="right">
          {formatNumber(item.monto)}
        </TableCell>
        <TableCell width={150} align="right">
          {Number(item.dias).toFixed(3)}
        </TableCell>
      </TableRow>
      {
        open
        && (
          <TableRow key={keyChild}>
            <TableCell colSpan={4} style={{ margin: '0px', padding: '0px' }}>
              <Table size="small" style={{ background: '#e6e6e6' }}>
                {
                  item.detail.map((detail) => {
                    const keyRowDetail = `row-detail-${item.id}-${detail.id}`;
                    return (
                      <TableRow key={keyRowDetail}>
                        <TableCell>
                          {detail.canal}
                        </TableCell>
                        <TableCell width={150} align="right">
                          {detail.cantidad}
                        </TableCell>
                        <TableCell width={150} align="right">
                          {formatNumber(detail.monto)}
                        </TableCell>
                        <TableCell width={150} align="right">
                          {Number(detail.dias).toFixed(3)}
                        </TableCell>
                      </TableRow>
                    );
                  })
                }
              </Table>
            </TableCell>
          </TableRow>
        )
      }
    </Fragment>
  );
};

export default FunnelDetail;
